import { render, staticRenderFns } from "./trade.vue?vue&type=template&id=24ba6da1&scoped=true&"
import script from "./trade.vue?vue&type=script&lang=js&"
export * from "./trade.vue?vue&type=script&lang=js&"
import style0 from "./trade.vue?vue&type=style&index=0&id=24ba6da1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ba6da1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24ba6da1')) {
      api.createRecord('24ba6da1', component.options)
    } else {
      api.reload('24ba6da1', component.options)
    }
    module.hot.accept("./trade.vue?vue&type=template&id=24ba6da1&scoped=true&", function () {
      api.rerender('24ba6da1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/trade/mining/trade.vue"
export default component.exports